<!-- <div class="padding bg-light-blue">
	<div class="flex center">
		<span class="flex center primary hover margin-right" (click)="onBack()" style="cursor: pointer">
			<i class="fa-solid fa-arrow-left margin-right-small"></i>
			Back
		</span>

		Orders
		<i class="fa-solid fa-angle-right padding-right-small padding-left-small grey"></i>
		{{ isCreateMode ? 'New order' : 'Order info' }}
	</div>
</div> -->

<!-- Button section -->
<div class="flex center bg-light-grey">
	@for (tab of tabs; track tab) {
	<div class="padding hover" [ngClass]="{ 'bg-primary white': tab.url === activeSubRoute, 'disabled': tab.disabled }" (click)="selectTab(tab.url)">
		<i class="fa-solid fa-angle-down margin-right-small"></i>
		{{ tab.title }}
	</div>
	}
</div>

<router-outlet />
